import React, { useEffect, useRef, useState } from 'react';
import styles from './LeagueAddEdit.module.scss';
import { Box, Button, Card, CardContent, Chip, CircularProgress, IconButton, Link, Typography } from '@mui/material';
import { Close, Delete } from '@mui/icons-material';
import { useFieldArray, useForm } from 'react-hook-form';
import InputCustom from '../InputCustom/InputCustom';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { uploadFile } from '../../../redux/actions/app/uploadFile';
import PrevImage from '../PrevImage/PrevImage';
import Loading from '../Loading/Loading';
import { resetDeleteItem, resetLeagueCreate, resetLeagueEdit, resetUploadFile } from '../../../redux/slices/app.slice';
import { leagueCreate } from '../../../redux/actions/app/leagueCreate';
import InfoAlert from '../InfoAlert/InfoAlert';
import { leagueList } from '../../../redux/actions/app/leagueList';
import { toast } from 'react-toastify';
import { leagueEdit } from '../../../redux/actions/app/leagueEdit';
import Swal from 'sweetalert2';
import { deleteItem } from '../../../redux/actions/app/deleteItem';
import DeleteBtn from '../DeleteBtn/DeleteBtn';
const LeagueAddEdit = ({ league, type, onClose }) => {
  const form = useForm();
  const formUser = useForm();
  const {
    fields: managers,
    append: appendManager,
    remove: removeManager,
  } = useFieldArray({
    control: form.control,
    keyName: 'key',
    name: 'users',
  });
  const [showAlert, setShowAlert] = useState(false);
  const {
    leagueList: { data: leagueListData, loading: leagueListLoading },
  } = useSelector((state) => state.app);
  const {
    leagueCreate: { data: leagueCreateData, loading: leagueCreateLoading },
    leagueEdit: { data: leagueEditData, loading: leagueEditLoading },
    deleteItem: { data: deleteItemData, loading: deleteItemLoading },
  } = useSelector((state) => state.app);
  const {
    uploadFile: { data: uploadFileData, loading: uploadFileLoading },
  } = useSelector((state) => state.app);
  useEffect(() => {
    if (deleteItemData) {
      toast.success('Лига удалена');
      onClose();
      dispatch(leagueList());

      dispatch(resetDeleteItem());
    }
  }, [deleteItemData]);

  useEffect(() => {
    if (league && (type == 'edit' || type == 'editChildren')) {
      form.setValue('name', league.name);
      form.setValue('image', league.logo);
      const leagueUsers = league?.leagueUsers?.map(({ user }) => {
        appendManager({
          avatar: user?.avatar,
          value: user?.id,
          label: `${user?.lastName} ${user?.firstName}`,
        });
      });

      // appendManager(leagueUsers);
      // form.setValue('users', );
      console.log(leagueUsers);
    }
  }, [league]);

  useEffect(() => {
    if (leagueCreateData) {
      toast.success('Лига создана');
      onClose();
      dispatch(leagueList());

      dispatch(resetLeagueCreate());
    }
  }, [leagueCreateData]);
  useEffect(() => {
    if (leagueEditData) {
      toast.success('Лига отредактирована');
      onClose();
      dispatch(leagueList());

      dispatch(resetLeagueEdit());
    }
  }, [leagueEditData]);
  useEffect(() => {
    if (uploadFileData) {
      form.clearErrors('image');
      form.setValue('image', uploadFileData?.url);
      dispatch(resetUploadFile());
    }
  }, [uploadFileData]);
  useEffect(() => {
    form.register('image', { required: true });
  }, []);
  const imageError = form.formState.errors?.image;
  const [userList, setUserList] = useState([]);
  useEffect(() => {
    if (!userList?.length) {
      const userListFormat = leagueListData?.users?.map((user) => ({
        avatar: user?.avatar,
        value: user?.id,
        label: `${user?.lastName} ${user?.firstName}`,
      }));
      setUserList(userListFormat);
    }
  }, [leagueListData]);

  const getTitle = () => {
    switch (type) {
      case 'create':
        return 'Создание лиги';
      case 'createChildren':
        return 'Создание подлиги';
      case 'edit':
        return 'Редактирование лиги';
      case 'editChildren':
        return 'Редактирование подлиги';
        break;

      default:
        break;
    }
  };
  const dispatch = useDispatch();
  const newUser = formUser.watch('newUser');
  console.log(managers);
  const navigate = useNavigate();
  const refFile = useRef();
  const onSubmit = (data) => {
    const { name, image, users } = data;
    const usersData = users?.map((user) => user.value);
    if (type?.includes('edit')) {
      dispatch(leagueEdit({ name, image, users: usersData, leagueId: league?.id }));
    } else {
      dispatch(leagueCreate({ name, image, users: usersData, parentId: league?.id }));
    }

    console.log(data);
  };
  return (
    <Card
      sx={{
        boxShadow: 3,
        '&.MuiPaper-root': {
          overflow: 'visible',
        },
      }}>
      <Box sx={{ padding: '16px 16px 24px 16px' }}>
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h5" sx={{ fontSize: '20px', fontWeight: '600' }}>
            {getTitle()}
          </Typography>
          <IconButton sx={{ padding: 0 }} onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
        {type == 'createChildren' ? (
          <>
            <Typography variant="h6" sx={{ mb: 0.5, fontSize: '16px', fontWeight: '600' }}>
              Родительская лига
            </Typography>
            <Chip
              sx={{ mb: 2 }}
              label={
                <Box sx={{ ml: -1, display: 'grid', alignItems: 'center', gap: 1, gridTemplateColumns: '24px 1fr' }}>
                  <Box component={'img'} src={league?.logo} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '50%', margin: '0 auto' }}></Box>
                  <Box sx={{ fontSize: '14px' }}>{league?.name}</Box>
                </Box>
              }
              variant="outlined"
            />
          </>
        ) : type == 'editChildren' ? (
          <>
            <Typography variant="h6" sx={{ mb: 0.5, fontSize: '16px', fontWeight: '600' }}>
              Родительская лига
            </Typography>
            <Chip
              sx={{ mb: 2 }}
              label={
                <Box sx={{ ml: -1, display: 'grid', alignItems: 'center', gap: 1, gridTemplateColumns: '24px 1fr' }}>
                  <Box component={'img'} src={league?.parent?.logo} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '50%', margin: '0 auto' }}></Box>
                  <Box sx={{ fontSize: '14px' }}>{league?.parent?.name}</Box>
                </Box>
              }
              variant="outlined"
            />
          </>
        ) : (
          <></>
        )}
        <Box sx={{ position: 'relative', mb: 2, alignItems: 'start', display: 'flex', flexDirection: 'column', maxWidth: '120px', gap: 0.5 }}>
          <PrevImage form={form} name={'image'} label={'Логотип'} />
          <Button
            disabled={uploadFileLoading}
            sx={{ width: '100%' }}
            onClick={() => {
              refFile.current.click();
            }}
            color={imageError ? 'error' : 'primary'}
            size="small"
            variant="outlined">
            Загрузить
          </Button>
          {imageError && <Box sx={{ color: 'error.main', fontSize: '12px' }}>Загрузите логотип</Box>}
          {uploadFileLoading && (
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}>
              <CircularProgress />
            </Box>
          )}
        </Box>
        <input
          style={{ display: 'none', width: 0, height: 0 }}
          ref={refFile}
          accept="image/*"
          multiple="false"
          type="file"
          onChange={(e) => {
            if (e.target.files[0]) {
              const formData = new FormData();
              formData.append('file', e.target.files[0]);
              dispatch(uploadFile(formData));
            }
          }}
        />
        <InputCustom required={true} form={form} name={'name'} label={'Название'} />
        <Typography variant="h6" sx={{ mt: 1, mb: 0, fontSize: '16px', fontWeight: '600' }}>
          Управляющие
        </Typography>
        <Box sx={{ mt: 1, display: 'grid', gap: 1, gridTemplateColumns: '32px auto 24px', alignItems: 'center' }}>
          {' '}
          {managers?.map((item, index) => (
            <>
              <Box component={'img'} src={item?.avatar} sx={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '50%', margin: '0 auto' }}></Box>
              <Box sx={{ fontSize: '16px' }}>{item?.label}</Box>
              <IconButton
                onClick={() => {
                  removeManager(index);
                }}>
                <Delete color="error" />
              </IconButton>
            </>
          ))}
        </Box>

        <Box sx={{ mt: 2, gap: 1, display: 'grid', gridTemplateColumns: '1fr auto' }}>
          <InputCustom isSelect options={userList?.filter((userItem) => !managers?.find((manager) => manager?.value == userItem?.value))} form={formUser} name={'newUser'} label={'Пользователь'} />

          <Button
            sx={{ mb: 1, height: '40px' }}
            onClick={() => {
              if (newUser) {
                appendManager(userList?.find((usr) => usr?.value == newUser));
                formUser.setValue('newUser', null);
                formUser.clearErrors('newUser');
              } else {
                formUser.trigger('newUser');
              }
            }}
            size="small"
            variant="outlined">
            Добавить
          </Button>
        </Box>
        <Box sx={{ mt: 8, display: 'grid', gridTemplateColumns: type?.includes('edit') ? '1fr 1fr' : '1fr', gap: 1 }}>
          {type?.includes('edit') ? (
            <DeleteBtn
              status="DELETED"
              type="LEAGUE"
              id={league?.id}
              successText={'Лига удалена'}
              confirmTitle={`Вы уверены что хотите удалить ${type == 'editChildren' ? 'подлигу' : 'лигу'} ?`}
              confirmText={type == 'editChildren' ? '' : 'Подлиги будут также удалены!'}
              onDelete={() => {
                onClose();
                dispatch(leagueList());
              }}
            />
          ) : (
            <></>
          )}

          <Button sx={{ height: '40px' }} onClick={form.handleSubmit(onSubmit)} size="medium" variant="contained">
            {type?.includes('edit') ? 'Сохранить' : 'Создать'}
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default LeagueAddEdit;
